export default __webpack_public_path__ + "static/media/information--truck-parking--g1.344e6e89.png";